/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_R_License_AcInputs */

const en_pc_cmp_r_license_ac = /** @type {(inputs: Pc_Cmp_R_License_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietary subscription`)
};

const zh_pc_cmp_r_license_ac = /** @type {(inputs: Pc_Cmp_R_License_AcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`闭源订阅制`)
};

/**
* | output |
* | --- |
* | "Proprietary subscription" |
*
* @param {Pc_Cmp_R_License_AcInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_r_license_ac = /** @type {((inputs?: Pc_Cmp_R_License_AcInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_R_License_AcInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_r_license_ac(inputs)
	return zh_pc_cmp_r_license_ac(inputs)
});
export { pc_cmp_r_license_ac as "pc.cmp.r.license.ac" }